import React, { Suspense, lazy } from 'react';
import { Segment, Sidebar } from 'semantic-ui-react';
import MenuBar from './menu-bar';
import { RouteComponentProps } from 'react-router-dom';
import { route } from 'src/app/route';
import { HeaderBar } from 'src/components/header-bar';
import { appConfig } from 'src/app';
const ImportManager = lazy(() => import('src/components/import/import-manager'));
const ImportManagerMobile = lazy(() => import('src/components/import/import-manager-mobile'));

export class ImportPage extends React.PureComponent<RouteComponentProps<{}>> {
  public componentDidMount() {
    document.title = route.getPageTitle(this.props.location.pathname);
  }

  public render() {
    const title = route.getPageTitle(this.props.location.pathname);
    return (
      <Sidebar.Pushable as={Segment} className='x-page'>
        <MenuBar />

        <Sidebar.Pusher>
          <Segment basic={true}>
            <HeaderBar title={title} />
            <Suspense fallback={<div className='x-loading' />}>
              {appConfig.isMobile ?
                <ImportManagerMobile />
                :
                <ImportManager />
              }
            </Suspense>
          </Segment>
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}
